import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChevronDoubleLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.14645 3.14645C7.34171 2.95118 7.65829 2.95118 7.85355 3.14645C8.04882 3.34171 8.04882 3.65829 7.85355 3.85355L3.70711 8L7.85355 12.1464C8.04882 12.3417 8.04882 12.6583 7.85355 12.8536C7.65829 13.0488 7.34171 13.0488 7.14645 12.8536L2.64645 8.35355C2.45118 8.15829 2.45118 7.84171 2.64645 7.64645L7.14645 3.14645ZM12.1464 3.14645C12.3417 2.95118 12.6583 2.95118 12.8536 3.14645C13.0488 3.34171 13.0488 3.65829 12.8536 3.85355L8.70711 8L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L7.64645 8.35355C7.45118 8.15829 7.45118 7.84171 7.64645 7.64645L12.1464 3.14645Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ChevronDoubleLeft
